module.exports = __webpack_public_path__ + "img/atf.4ab43cc9.svg";